import {isArrayNullUndefinedOrEmpty} from "../../../../services/Validator";
import {FlashResultsQuestionsList} from "../../../lists/courses/flash/FlashResultsQuestionsList";

export default function FlashResultsTabletQuestionsCard({questions, levelA}) {
    // Used in FlashResultsScreen to display questions list
    // in tablet mode

    // BUILD
    if (isArrayNullUndefinedOrEmpty(questions))
        return null;
    return (
        <div className={"overflow-auto w-full grow hidden lg:hidden sm:flex sm:flex-col bg-backgroundLight5 shadow-[inset_0px_1px_2px_rgba(82,96,120,1)] rounded-[16px] mt-24"}>
            <FlashResultsQuestionsList levelA={levelA}
                                       questions={questions} />
        </div>
    );
}